import { ValueGetterFunc, ValueGetterParams } from 'ag-grid-community';
import { EmptyCell } from '../../formatters/genericFormatters';
import { useGetGeofenceListQuery } from '@customer/store/apis/geofencesApi';
import { useCallback } from 'react';
import { GIListModel, GIType } from '@customer/store/apis/interactionsApi';

/** Determine the appropriate asset/geofence name to display in the geofence column. */
export const useGeofenceNameValueGetter = <
  TData extends Pick<GIListModel, 'it' | 'geo' | 'roNa'>,
>(): ValueGetterFunc<TData, string> => {
  const { data: geofences } = useGetGeofenceListQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  // Return a single name as the cell value (for sorting and searching to work by default).
  const valueGetter = useCallback(
    ({ data }: ValueGetterParams<TData, string>): string => {
      let name: string | undefined;

      if (data) {
        // For GeofenceSpeedingRoadworks interactions, use the name of the roadworks vehicle (RO name).
        if (data.it === GIType.GeofenceSpeedingRoadworks && data.roNa) {
          name = data.roNa;
        }
        // For all other interaction types, try to look up and use the name of the geofence.
        else if (typeof data.geo === 'number' && geofences) {
          const geofenceMatch = geofences?.find(({ id }) => id === data.geo);
          if (geofenceMatch) {
            name = geofenceMatch.n;
          }
        }
      }

      return name ?? EmptyCell;
    },
    [geofences],
  );

  return valueGetter;
};
